import { render, staticRenderFns } from "./LocationHistoryComponent.vue?vue&type=template&id=e5bcedf2&scoped=true"
import script from "./LocationHistoryComponent.vue?vue&type=script&lang=js"
export * from "./LocationHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./LocationHistoryComponent.vue?vue&type=style&index=0&id=e5bcedf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bcedf2",
  null
  
)

export default component.exports